import { createGlobalStyle } from 'styled-components';

import { tokens } from './tokens';

import backgroundImg from '~/assets/images/backgrounds/background.png';

export default createGlobalStyle`
  :root {
    --primary-color: ${tokens.colors.primary};
    --primary-hover: ${tokens.colors.primaryHover};
    --primary-light: ${tokens.colors.primaryLight};
    --text-color: ${tokens.colors.text};
    --bg-color: ${tokens.colors.background};
    --border-color: ${tokens.colors.border};
    --secondary-text-color: ${tokens.colors.secondaryText};
    --antd-wave-shadow-color: ${tokens.colors.primary};
  }

  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body, #root {
    height: 100%;
  }

  body {
    min-height: 100vh;
    background-image: url(${backgroundImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
    background-color: var(--bg-color);
    color: var(--text-color);
    font: ${tokens.typography.fontSize}px ${tokens.typography.fontFamily};
    -webkit-font-smoothing: antialiased;

    @media (max-width: 576px) {
      background-image: none;
      background-color: white;
    }
  }

  body, input, button, label {
    font: ${tokens.typography.fontSize}px ${tokens.typography.fontFamily};
  }

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;

    &:focus {
      outline: 0;
    }
  }

  html {
    --antd-wave-shadow-color: ${tokens.colors.primary};
  }

  a {
    text-decoration: none;
    color: ${tokens.colors.primary};

    &:hover {
      color: ${tokens.colors.primaryHover};
    }
  }

  .ant-tabs-tab {
    font-weight: 700;

    &-active {
      color: var(--primary-color) !important;
      border-bottom: 2px solid var(--primary-color) !important;
    }
  }

  .ant-menu-submenu-selected > .ant-menu-submenu-title {
    color: var(--secondary-text-color) !important;
  }
`;
